import { useContext, useEffect, useState } from 'react';
import BackIcon from '../../assets/Demat/back_icn_btn.svg'
import { getClientIp } from '../../helperFunctions/helperFunctions';
import { Context } from '../../services/apiContext';


export default function SummaryCounterArea({referral_id,onButtonClicked,...props}){
    const  [state,setState] =  useState({leads:0,opened:0,earnings:0})
    const [error,setError] = useState(false)
    const buttons = [
        {
            name:"Total Earnings ",
            value:` ${state.earnings?`₹ ${state.earnings}` : '--'}`,
            link: ""
        },
 
        {
            name:"Referral Leads",
            value: ` ${state.leads||'--'}`,
            link: ""
        },
        {
            name:"Accounts Opened",
            value: ` ${state.opened||'--'}`,
            link: ""
        },
    ]
    const contextapi = useContext(Context);

    async function fetchFromAPI(){

        const user_ip =   await getClientIp()

        const url = '/referral/refearnings'
        const payload = {
            referral_id ,
            user_ip
        }



        await contextapi
        .postApiCalling(url, payload)
        .then((res) => {
        //   console.log(res);
          if (res.status_desc == "Success") {
          
           
            const {leads,opened,earnings} = res 
            setState({leads,opened,earnings})
            // console.log(res.msg);
            // console.log(dashboardDetails);
          }
        })
        .catch((error) => {
          console.log(error);
          setError(true)
          alert('Error fetching referral data')
          // setNotifi({ val: true, msg: "Something went wrong" });
        });
    }

    useEffect(()=>{
        if(referral_id){
            fetchFromAPI()
        }
    },[referral_id])

    const circleRadius = '38px'

    return <div className="container-fluid my-4 "
    >

        <div className="row gx-4 ">

            {buttons.map(
                (button,i) => 
                <div className="col px-4 " key={i} >
                <div className={`  border p-2 d-flex align-items-center ${i?'':''} `}
                    style={{borderRadius:"72px",backgroundColor:'lightblue',border:"3px solid gray",backgroundColor:'#f1f7ff',
                        cursor:'pointer'
                
                    }}
                    onClick={()=>onButtonClicked(i+1)}

                >
                    <p className="m-0 ms-4 "
                        style={{fontSize:'1.0em'}}
                    >
                        {button.name}: <span style={{fontWeight:'bolder'}}>{button.value}</span>
                    </p>

                    <button className="ms-auto border-0 bg-white"
                    style={{borderRadius:'72px',height:'100%',width:circleRadius,height:circleRadius}}
                        onClick={()=>onButtonClicked(i+1)}
                    >

                        <img src={BackIcon} style={{transform:'scale(-1)',width:'28px',height:'20px'}} />
                    </button>
                </div>
                </div>
            )}

        </div>
    
    </div>
    
}